import { render } from "./PlaceDashboard.vue?vue&type=template&id=5ab4abaa&scoped=true"
import script from "./PlaceDashboard.vue?vue&type=script&lang=js"
export * from "./PlaceDashboard.vue?vue&type=script&lang=js"

import "./PlaceDashboard.vue?vue&type=style&index=0&id=5ab4abaa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ab4abaa"]])

export default __exports__